
export default function rhGallery(container) {
    
  let columns = Math.ceil(container.clientWidth / 600) || container.dataset.rhColumns || 3;


  positionImages(container)
  window.addEventListener('resize', e => {
    let newColumns = Math.ceil(container.clientWidth / 600);    
    //if(newColumns == columns) return false;
    columns = newColumns;

    positionImages(container)
  })
  
}

function positionImages(container) {
    
  const images = container.children;
  const elements = [...images].map(el => { return {ref:el,size:parseInt(el.dataset.rhSize)}});
  let length = elements.reduce((sum,el)=> sum + el.size,0);
  const scale = container.dataset.hasOwnProperty('rhScale');
  const columnWidth = container.dataset.rhColumn || 600;
  let positioned = 0;

  let columns = Math.floor(container.clientWidth / columnWidth) || 1;
  const maxColumns = container.dataset.rhMaxColumns || 999;
  columns = columns > maxColumns ? maxColumns : columns;
  elements.forEach((el,index) => {
    let {ref,size} = el;
    const added = rows - (positioned + size);
    if(added == 1 && elements[index+1].size != 1) size += 1;
    if (added == -1) ref.style.gridColumn = "+1"; 
    if(length - positioned < size) size = length - positioned;
    if(scale && !((index+1)%5) && (index < elements.length - columns)) {
      ref.style.gridColumn = `span 2`
      ref.style.gridRow = `span ${size*2}`
      length += 2;
    } else {
      ref.style.gridRow = `span ${size}`
      positioned += size;
    }
  })  
  const rows = columns ? Math.floor(length / columns) : 1;
  container.style.gridTemplate = `repeat(${rows},auto) / repeat(${columns},1fr)`;
};